<template>
  <div class="container col-4">
    <!--         {{ calibres }} <br>
        {{ selectedCalibres }} -->

    <label for="">Calibre Arma</label>
    <v-select
      v-model="selectedCalibres"
      :items="calibres"
      label="Calibre"
      multiple
      hint="Selecciona el calibre"
      persistent-hint
      item-text="item.descripcion"
      item-value="item.descripcion"
    >
    </v-select>

    <label for="">Documento</label>
    <v-select
      v-model="selectedDocumentos"
      :items="documentos"
      label="documento"
      multiple
      hint="Selecciona el Documento"
      persistent-hint
      item-text="item.tipo_documento"
      item-value="item.tipo_documento"
    >
    </v-select>

    <label for="">Tipo de Arma</label>
    <v-select
      v-model="selectedTipoArma"
      :items="tipoarmas"
      label="Tipo de Arma"
      multiple
      hint="Selecciona el tipo de Arma"
      persistent-hint
      item-text="item.descripcion"
      item-value="item.descripcion"
    >
    </v-select>

    <label for="">Pais de Procedencia</label>
    <v-select
      v-model="selectedProcedencia"
      :items="procedencias"
      label="Pais de Procedencia"
      multiple
      hint="Selecciona el Pais de Procedencia"
      persistent-hint
      item-text="item.descripcion"
      item-value="item.descripcion"
    >
    </v-select>

    <label for="">Clasificacion de Armas</label>
    <v-select
      v-model="selectedClasificacionarma"
      :items="clasificacionarmas"
      label="Clasificacion de Arma"
      multiple
      hint="Selecciona la Clasificacion de Arma"
      persistent-hint
      item-text="item.descripcion"
      item-value="item.descripcion"
    >
    </v-select>
    <div>
      <label for="selectOption">Selecciona el Documento: </label>
      <select
        class="form-select"
        id="selectOption"
        aria-label="Default select example"
      >
        <!-- <option selected>Calibre</option> -->
        <option
          v-for="item in optionsdoc"
          :key="item.cod_documento"
          :value="item.cod_documento"
        >
          {{ item.cod_documento }} - {{ item.tipo_documento }}
        </option>
      </select>
    </div>
    <div>
        <label for="selectOption">Seleccione el Calibre: </label>
        <select
          class="form-select"
          id="selectOption"
          aria-label="Default select example"
        >
          <!-- <option selected>Calibre</option> -->
          <option
            v-for="item in optionscalibre"
            :key="item.codigo_calibre"
            :value="item.descripcion"
          >
            {{ item.codigo_calibre }} - {{ item.descripcion }}
          </option>
        </select>
      </div>
      <div>
          <label for="selectOption">Seleccione el Tipo de Arma: </label>
          <select
            class="form-select"
            id="selectOption"
            aria-label="Default select example"
          >
            <!-- <option selected>Calibre</option> -->
            <option
              v-for="item in optionstipoarma"
              :key="item.codigo_tipo"
              :value="item.descripcion"
            >
              {{ item.codigo_tipo }} - {{ item.descripcion }}
            </option>
          </select>
        </div>
        <div>
            <label for="selectOption">Seleccione el Pais de Procedencia: </label>
            <select
              class="form-select"
              id="selectOption"
              aria-label="Default select example"
            >
              <!-- <option selected>Calibre</option> -->
              <option
                v-for="item in optionsprocedencia"
                :key="item.codigo_origen"
                :value="item.descripcion"
              >
                {{ item.codigo_origen }} - {{ item.descripcion }}
              </option>
            </select>
          </div>
          <div>
              <label for="selectOption">clasificacion: </label>
              <select
                class="form-select"
                id="selectOption"
                aria-label="Default select example"
              >
                <!-- <option selected>Calibre</option> -->
                <option
                  v-for="item in optionsclasificacion"
                  :key="item.codigo_clasificacion"
                  :value="item.descripcion"
                >
                  {{ item.codigo_clasificacion }} - {{ item.descripcion }}
                </option>
              </select>
            </div>
  </div>
</template>
<script>
//import { loadDatadocumento2 } from "./Selects";
import Selects from "@/services/Selects";

export default {
  data() {
    return {
      optionsdoc: [],
      optionscalibre: [],
      optionstipoarma: [],
      optionsprocedencia: [],
      optionsclasificacion: [],
    };
  },
  async mounted() {
    const selectdocs = new Selects();  //--1
    const selectcalibre = new Selects();  //--2
    const data = await selectdocs.loadDatadocumento2();  //--1
    const datacalibre = await selectcalibre.loadDataCalibres2();  //--2
    this.optionsdoc = data;  //--1
    this.optionscalibre = datacalibre;   //--2
    console.log("Datos cargados:", data);  //--1
    console.log("Datos cargados:", datacalibre);  //--2
    const selecttipoarm = new Selects();  //--3
    const datatipoarm = await selecttipoarm.loadDataTipoArma2();  //--3
    this.optionstipoarma = datatipoarm;  //--3
    console.log("Datos cargados:", datatipoarm);  //--3
     const selectprocedencia= new Selects();  //--4
    const dataprocedencia = await selectprocedencia.loadDataProcedencia2();  //--4
    this.optionsprocedencia = dataprocedencia;  //--4
    console.log("Datos cargados:", dataprocedencia);  //--4
     const selectclasificacion = new Selects();  //--5
    const dataclasificacion = await selectclasificacion.loadDataClasificacionarma2();  //--5
    this.optionsclasificacion = dataclasificacion;  //--5
    console.log("Datos cargados:", dataclasificacion);  //--5
  }
};
</script>
<!-- <script>
import axios from "axios";
export default {
  data() {
    return {
      options: [],
    };
  },
  mounted() {
    this.cargarOpcionesDesdeAPI();
  },
  methods: {
    async cargarOpcionesDesdeAPI() {
      console.log("Cargando opciones desde la API...");
      try {
        const response = await axios.get("http://127.0.0.1:8000/api/documento"); // Reemplaza con la URL de tu API
        if (response.status === 200) {
          this.options = response.data.post;
        } else {
          console.error("Error al cargar datos desde la API");
        }
      } catch (error) {
        console.error("Error al cargar opciones desde la API:", error);
      }
    },
  },
};
</script> -->

<!-- <script>
import { defineComponent } from "vue";
import Selects from "@/services/Selects";

export default defineComponent({
  data() {
    var selectedCalibres = [];
    var selectedDocumentos = [];
    var selectedTipoArma = [];
    var selectedProcedencia = [];
    var selectedClasificacionarma = [];
    return {
      selectedCalibres,
      selectedDocumentos,
      selectedTipoArma,
      selectedProcedencia,
      selectedClasificacionarma,
      calibres: [],
      documentos: [],
      tipoarmas: [],
      procedencias: [],
      clasificacionarmas: [],
    };
  },
  async created() {
    const selectService = new Selects();
    const selectServiceDocumento = new Selects();
    const selectServiceTipoArma = new Selects();
    const selectServiceProcedencia = new Selects();
    const selectServiceClasificacionarma = new Selects();
    const data = await selectService.loadDataCalibres();
    const dataDoc = await selectServiceDocumento.loadDatadocumento();
    const dataTipArm = await selectServiceTipoArma.loadDataTipoArma();
    const dataProcedencia =
      await selectServiceProcedencia.loadDataProcedencia();
    const dataClasificacionarma =
      await selectServiceClasificacionarma.loadDataClasificacionarma();
    if (Array.isArray(dataClasificacionarma)) {
      this.clasificacionarmas = dataClasificacionarma;
    } else {
      console.error(
        "Los datos cargados no son un array:",
        dataClasificacionarma
      );
    }
    if (Array.isArray(dataProcedencia)) {
      this.procedencias = dataProcedencia;
    } else {
      console.error("Los datos cargados no son un array:", dataProcedencia);
    }
    if (Array.isArray(dataTipArm)) {
      this.tipoarmas = dataTipArm;
    } else {
      console.error("Los datos cargados no son un array:", dataTipArm);
    }
    if (Array.isArray(dataDoc)) {
      this.documentos = dataDoc;
    } else {
      console.error("Los datos cargados no son un array:", dataDoc);
    }
    if (Array.isArray(data)) {
      this.calibres = data;
      /*             this.calibres.forEach(item => {
                console.log("Descripción:", item.descripcion);
            }); */
    } else {
      console.error("Los datos cargados no son un array:", data);
    }
  },
});
</script>
 -->
